"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _withCustomPaletteColor = _interopRequireDefault(require("../withCustomPaletteColor"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  padding: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var StyledIconButton = (0, _styledComponents.default)(_core.IconButton)(_templateObject(), function (props) {
  return props.size === 'small' ? '6px' : '12px';
});

var IconButton = function IconButton(_ref) {
  var props = _extends({}, _ref);

  return _react.default.createElement(StyledIconButton, props);
};

IconButton.defaultProps = {
  size: 'medium',
  color: 'default'
};

var _default = (0, _withCustomPaletteColor.default)(IconButton);

exports.default = _default;